/** 创建页面广播 */
export function createBroadcastChannel(event: string): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') {
    console.warn('BroadcastChannel is not supported in this browser.');
    return null;
  }
  return new BroadcastChannel(event);
}
